import * as React from "react";
import { Query, QueryResult } from "react-apollo";
import { GetRolesQuery } from "../../__generated__/types";
import { ROLES_QUERY } from "./queries";

export class RolesQuery extends Query<GetRolesQuery> {}

interface Props {
  children(props: QueryResult<GetRolesQuery>): React.ReactNode;
}

export default ({ children }: Props) => {
  return (
    <RolesQuery query={ROLES_QUERY}>{result => children(result)}</RolesQuery>
  );
};



// WEBPACK FOOTER //
// ./src/queries/RolesQuery/RolesQuery.tsx